export interface SectionFace {
    className?: string,
    title: string | React.ReactNode,
    description?: string | React.ReactNode,
    note?: string,
    button?: React.ReactNode,
    children?: React.ReactNode
}

export interface ISheetsAndSlack {
    firstName?: string,
    lastName: string,
    description: string,
    jobTitle: string,
    companyName?: string,
    numberOfEmployees?: string,
    email?: string
}

export const companySizeArr = [
    { value: 'myself only', label: 'Myself only' },
    { value: '1 - 10 employees', label: '1 - 10 Employees' },
    { value: '11 - 50 employees', label: '11 - 50 Employees' },
    { value: '51 - 200 employees', label: '51 - 200 Employees' },
    { value: '201 - 500 employees', label: '201 - 500 Employees' },
    { value: '501 - 1000 employees', label: '501 - 1000 Employees' },
    { value: '1001 - 5000 employees', label: '1001 - 5000 Employees' },
    { value: '5001 - 10,000 employees', label: '5001 - 10,000 Employees' },
    { value: '10,001+ employees', label: '10,001+ Employees' }
]

export interface CountryOption {
    value: string
    label: string
    icon: React.ReactNode
}

export interface CountrySelectProps {
    options: CountryOption[]
    value?: string
    onChange: (value: string) => void
    disabled?: boolean
    name?: string
    required?: boolean
    className?: string
    iconComponent?: React.ComponentType<{ country: string; label: string }>
}

export interface BookADemoData {
    firstName: string,
    lastName: string,
    jobTitle: string,
    email: string,
    phone: string,
    companyName: string,
    receiveEmails: boolean
}

export enum CTAType {
    Book = 'book',
    Trial = 'trial'
}

export interface ILandingPageContent {
    headline: string;
    subHeadline: string;
    cta: CTAType[];
    disclaimer?: string;
};
export enum BookADemoSteps {
    PERSONAL_INFO = 0,
    DATE_TIME = 1
}
